import {
  collection,
  doc,
  CollectionReference,
  DocumentReference,
} from 'firebase/firestore';
import { db } from '../config/firebase';
import {
  University,
  Vehicle,
  Trip,
  TripSeat,
  Booking,
  BookingGroup,
  StudentProfile,
  DemandRequest,
  StudentDemandRecord,
  AdminUser,
  AuditLog,
} from '../../types';

// Collection Names Constants
export const COLLECTIONS = {
  UNIVERSITIES: 'universities',
  VEHICLES: 'vehicles',
  TRIPS: 'trips',
  SEATS: 'seats',
  BOOKINGS: 'bookings',
  BOOKING_GROUPS: 'bookingGroups',
  STUDENTS: 'students',
  DEMAND_REQUESTS: 'demandRequests',
  STUDENT_DEMAND: 'studentDemand',
  DEMAND_ANALYTICS: 'demandAnalytics',
  ADMINS: 'admins',
  AUDIT_LOGS: 'auditLogs',
  SETTINGS: 'settings',
} as const;

// Typed Root Collections
export const universitiesCol = collection(
  db,
  COLLECTIONS.UNIVERSITIES
) as CollectionReference<University>;

export const vehiclesCol = collection(
  db,
  COLLECTIONS.VEHICLES
) as CollectionReference<Vehicle>;

export const tripsCol = collection(
  db,
  COLLECTIONS.TRIPS
) as CollectionReference<Trip>;

export const bookingsCol = collection(
  db,
  COLLECTIONS.BOOKINGS
) as CollectionReference<Booking>;

export const bookingGroupsCol = collection(
  db,
  COLLECTIONS.BOOKING_GROUPS
) as CollectionReference<BookingGroup>;

export const studentsCol = collection(
  db,
  COLLECTIONS.STUDENTS
) as CollectionReference<StudentProfile>;

export const demandRequestsCol = collection(
  db,
  COLLECTIONS.DEMAND_REQUESTS
) as CollectionReference<DemandRequest>;

export const studentDemandCol = collection(
  db,
  COLLECTIONS.STUDENT_DEMAND
) as CollectionReference<StudentDemandRecord>;

export const demandAnalyticsCol = collection(
  db,
  COLLECTIONS.DEMAND_ANALYTICS
);

export const adminsCol = collection(
  db,
  COLLECTIONS.ADMINS
) as CollectionReference<AdminUser>;

export const auditLogsCol = collection(
  db,
  COLLECTIONS.AUDIT_LOGS
) as CollectionReference<AuditLog>;

// Typed Document Helpers
export const getStudentDoc = (uid: string): DocumentReference<StudentProfile> => {
  return doc(db, COLLECTIONS.STUDENTS, uid) as DocumentReference<StudentProfile>;
};

// Typed Subcollection Helpers
export const getTripSeatsCol = (tripId: string): CollectionReference<TripSeat> => {
  return collection(db, COLLECTIONS.TRIPS, tripId, COLLECTIONS.SEATS) as CollectionReference<TripSeat>;
};

export const getTripSeatDoc = (tripId: string, seatNumber: number): DocumentReference<TripSeat> => {
  return doc(db, COLLECTIONS.TRIPS, tripId, COLLECTIONS.SEATS, String(seatNumber)) as DocumentReference<TripSeat>;
};
